<template>
  <div class="content-center none-click">
    <div class="banner">
      <img src="@/assets/Mobile/images/solution/distribute-banner.png" alt="">
    </div>
    <div class="block01">
      <div class="sk-mobile-title">
        <div class="title">业务场景</div>
        <div class="sub-title">打通厂商/品牌商和下游各级分销渠道，实现各分销渠道明确可控</div>
      </div>
      <img src="@/assets/Mobile/images/solution/distribute01.png" alt="">
    </div>
    <div class="block02">
      <div class="sk-mobile-title">
        <div class="title">产品介绍</div>
        <div class="sub-title">通过分销商管理平台统一管理下游分销商，实现商品、分销商、<br>会员、订单等数据打通</div>
      </div>
      <img src="@/assets/Mobile/images/solution/distribute02.png" alt="">
    </div>
    <div class="block03">
      <div class="sk-mobile-title">
        <div class="title">一件代销</div>
        <div class="sub-title">上游企业为下游零售商家提供商品一键代销服务，零售商家无需<br>进行备货，顾客购买代销商品后，系统自动生成向上游采购的批<br>发订单，由上游企业直接发货给顾客，零售终端获取商品差价。</div>
      </div>
      <img src="@/assets/Mobile/images/solution/distribute03.png" alt="">
    </div>
    <div class="block04">
      <div class="sk-mobile-title">
        <div class="title">适用客户</div>
      </div>
      <div class="content">
        <div class="item">
          <img src="@/assets/Mobile/images/solution/distribute04.png" alt="">
          <span>厂商</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/distribute05.png" alt="">
          <span>品牌商</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/distribute06.png" alt="">
          <span>大经销商</span>
        </div>
      </div>
    </div>
    <div class="block05">
      <div class="sk-mobile-title">
        <div class="title">定制流程</div>
      </div>
      <img src="@/assets/Mobile/images/solution/brand02.png" alt="">
    </div>
    <Case title="分销商城定制" />
    <ContactForm info-sources="分销商城定制" />
  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import ContactForm from '@/Mobile/Mobilecom/ContactForm'
import Case from '@/Mobile/Mobilecom/Case'

export default {
  metaInfo: metaInfo.DistributeCustom,
  components: {
    ContactForm,
    Case
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  height: 200px;
  margin-top: 50px;
  img {
    width: 100%;
  }
}
.block01 {
  img {
    width: 342px;
    margin: 18px 0 11px 0;
  }
}
.block02 {
  background-color: #F6FBFF;
  img {
    width: 342px;
    margin: 13px 0 17px 0;
  }
}
.block03 {
  background-color: #FAFAFA;
  img {
    width: 340px;
    margin: 22px 0;
  }
}
.block04 {
  .content {
    padding-top: 20px;
    .item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        width: 296px;
      }
      span {
        font-size: 14px;
        font-weight: 500;
        color: #595961;
        line-height: 20px;
        margin: 15px 0 30px 0;
      }
    }
  }
}
.block06 {
  .content {
    padding: 24px 0 14px 0;
    display: flex;
    width: 375px;
    flex-wrap: wrap;
    justify-content: space-evenly;
    .item {
      margin-top: 7px;
      display: flex;
      flex-direction: column;
      font-size: 6px;
      line-height: 16px;
      color: #000000;
    }
    img {
      width: 106px;
      height: 52px;
    }
  }
}
.block05 {
  img {
    margin: 16px 0 24px 0;
    width: 341px;
  }
}
</style>
